import Text from "common/Typography/Text";
import { formatDate } from "@shared/utils/date";
import Flex from "common/Boxes/Flex";
import React from "react";
import styled from "styled-components";
import ClockCircleOutlined from "@ant-design/icons/ClockCircleOutlined";

interface TradeTimeInfoProps {
  timestamp: number;
  isOpen?: boolean;
}

const TradeTimeInfo = ({ timestamp, isOpen }: TradeTimeInfoProps) => {
  return (
    <Flex $justifyContent="flex-start">
      <ClockIcon $isOpen={isOpen} />
      <Text>{formatDate(timestamp, true, true)}</Text>
    </Flex>
  );
};

export default TradeTimeInfo;

const ClockIcon = styled(ClockCircleOutlined)<{ $isOpen?: boolean }>`
  width: 14px;
  height: 14px;
  margin-right: 6px;
  color: ${(p) => (p.$isOpen ? p.theme.colors.green : p.theme.colors.red)};
`;
